import { CreditWallet } from '@modules/credit-wallet/Domain/Entities/credit-wallet.entity';
import { CreditPlan } from '@modules/credit-wallet/Domain/Enums/credit-plan.enum';

/** Raw shape returned by the creditWallet GraphQL query. */
export interface RawCreditWallet {
  id: string;
  tenantId: string;
  plan: string;
  initialPlanCredits: number;
  planCredits: number;
  planCreditsExpireAt: string | null;
  purchasedCredits: number;
  overConsumptionCredits: number;
}

/**
 * Maps a raw GraphQL response to a typed CreditWallet domain entity.
 * Pure function — no Angular, no side effects.
 */
export function adaptCreditWallet(raw: RawCreditWallet): CreditWallet {
  return new CreditWallet({
    id: raw.id,
    tenantId: raw.tenantId,
    plan: raw.plan as CreditPlan,
    initialPlanCredits: raw.initialPlanCredits,
    planCredits: raw.planCredits,
    planCreditsExpireAt: raw.planCreditsExpireAt ?? null,
    purchasedCredits: raw.purchasedCredits,
    overConsumptionCredits: raw.overConsumptionCredits,
  });
}
